import { css } from '@/styled-system/css';

export const specialOfferCard = css({
  backgroundColor: 'yellow.400',
  borderRadius: 'md',
  padding: 'default',
  _dark: {
    backgroundColor: 'bg.softest',
  },
});

export const specialOfferHeading = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tightest',
  fontSize: 'body',
  fontWeight: 'bold',
  color: 'text.neutral',
});

export const specialOfferBody = css({
  fontSize: 'body-sm',
  color: 'text.neutral',
  paddingTop: 'tightest',
});
